// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// Components
import Modal from '../modalReact/Modal';

// Styles
import './ProductList.css';
import {GetCurrency} from "../../utility/Utils";

const ProductList = (props) => {
  const [productId, setProductId] = useState('');

  useEffect(() => {
    console.log('TODO Watch This');
    scrollToCurrentProduct();
  })

  const handleProductClick = (productId) => {
    setProductId(productId)
    props.setModal(true);
  }

  const renderProductList = () => {
    const { currentProductId, products, s3path } = props;
    //console.log(currency, " currency")
    return (
        products && products.map(product => {
        const { id, name, price, discountedPrice, currency } = product;
        let { imageUrl } = product;
        imageUrl = s3path + imageUrl

        const current = (currentProductId && currentProductId === id) ? 'product-current' : '';
        const onSale = (price !== discountedPrice) ? 'product-onsale' : '';

        return (
          <div className={`product fl-shrink-0 pd-05 fl fl-nowrap br-all-sm ${current}`} key={id} onClick={() => handleProductClick(id)}>
            <div className="product-img no-overflow br-all-sm fl-shrink-0">
              <img src={imageUrl} alt={id} />
            </div>
            <div className="product-name pd-r-1 mg-l-1 fl fl-column fl-wrap fl-j-between fl-shrink-1">
              <div className="line-clamp-2">{name}</div>
              <div className={`product-price-wrapper ${onSale}`}>
                <span className="product-price">{`${GetCurrency(currency)}${price}`}</span>
                {onSale && (
                  <span className="product-discounted-price">{`${GetCurrency(currency)}${discountedPrice}`}</span>
                )}
              </div>
            </div>
          </div>
        )
      })
    )
  }

  const scrollToCurrentProduct = () => {
    const element = document.querySelector(".product-current");

    if (element) {
      const parent = document.querySelector('.products-container');
      const parentTop = parent.getBoundingClientRect().top;
      const childTop = element.getBoundingClientRect().top;

      parent.scroll({ top: childTop - parentTop - 10, behavior: "smooth" });
    }
  }

  const closeModal = () => {
    props.setModal(false);
  }

  const { showModal, products, s3path,currency, modalButtonTitle } = props;
  const imageApiUrl = s3path.substring(0, s3path.length-1)
  const product = products && products.find(product => product.id === productId)
  return (
    <div className="products-container bg-alt br-all pd-1">
      <div className="product-list fl fl-nowrap bg-alt br-all">
        {renderProductList()}
      </div>
      {showModal && Object.keys(product).length > 0 && (
        <Modal
            currency={currency}
            product={product}
            productId={productId}
            imageApiUrl={imageApiUrl}
            modalButtonTitle={modalButtonTitle}
            closeModal={closeModal} products={products} />
      )}
    </div>
  );
}

ProductList.propTypes = {
  currentProductId: PropTypes.string,
  setModal: PropTypes.func,
  showModal: PropTypes.bool,
};

export default ProductList;
